import useI18n from '@/shared/hooks/useI18n'
import { useSession } from '@/shared/hooks/useSession'
import { Container, LoadingScreen } from '@/shared/components'
import {
  Button,
  Card,
  H2,
  PageSection,
  Table,
  TableColumnHeader,
  TableRow
} from '@/common'
import { useOrganizationUsers } from '@/shared/hooks/api/organizationUsers'
import { useDialog } from '@/shared/hooks/useDialog'
import OrganizationUsersTableRow from './components/OrganizationUsersTableRow'
import InviteOrganizationUserDialog from '../../components/InviteOrganizationUserDialog'
import { useOrganizationAuditLogs } from '@/shared/hooks/api/auditLogs'
import OrganizationActivityListItem from './components/OrganizationActivityListItem'

export default function UsersListPage() {
  const { t } = useI18n()
  const {
    session: {
      organization: { id: organizationId }
    }
  } = useSession()
  const {
    open: isInviteUserToOrganizationDialogOpen,
    openDialog: openInviteUserDialog,
    closeDialog: onInviteUserDialogClose
  } = useDialog()
  const organizationUsersQuery = useOrganizationUsers(organizationId)
  const { data, isLoading } = organizationUsersQuery
  const { data: auditLogs, isLoading: auditLogsLoading } = useOrganizationAuditLogs(organizationId)

  if (isLoading || auditLogsLoading) {
    return <LoadingScreen />
  }

  return (
    <>
      <Container>
        <header className="flex justify-between items-center">
          <H2>{t('organizationUsers:pages.organizationUsers.title')}</H2>
        </header>

        <PageSection
          title={t('organizationUsers:sections.usersList.title')}
          actions={
            <Button sizeType="sm" onClick={openInviteUserDialog}>
              {t('organizationUsers:actions.inviteUser')}
            </Button>
          }
        >
          <Table>
            <thead>
              <TableRow>
                <TableColumnHeader>
                  {t('organizationUsers:sections.usersList.table.name')}
                </TableColumnHeader>
                <TableColumnHeader>
                  {t('organizationUsers:sections.usersList.table.email')}
                </TableColumnHeader>
                <TableColumnHeader colSpan={2}>
                  {t('organizationUsers:sections.usersList.table.role')}
                </TableColumnHeader>
              </TableRow>
            </thead>
            <tbody>
              {data?.map(user => (
                <OrganizationUsersTableRow key={user.id} user={user} />
              ))}
            </tbody>
          </Table>
        </PageSection>

        <PageSection title={t('organizationUsers:activities.title')}>
          <ul className="space-y-1">
            {auditLogs?.map((activity, index) => (
              <li key={`${activity.eventType}-${index}`}>
                <Card className="p-4">
                  <OrganizationActivityListItem activity={activity} />
                </Card>
              </li>
            ))}
          </ul>
        </PageSection>
      </Container>
      <InviteOrganizationUserDialog
        isOpen={isInviteUserToOrganizationDialogOpen}
        close={onInviteUserDialogClose}
      />
    </>
  )
}
